import dot from 'dot-prop-immutable';

import { type ActionWithPayload } from 'store/types';

import { types } from './actions';
import { type Collaborators } from './types';

type CollaboratorsState = {
  list: Collaborators;
  modalStatus: {
    isOpened: boolean;
  };
};

const initialState: CollaboratorsState = {
  list: {},
  modalStatus: {
    isOpened: false,
  },
};

type CollaboratorsAction =
  | ActionWithPayload<typeof types.RECEIVE_COLLABORATORS, Collaborators>
  | ActionWithPayload<typeof types.SET_MODAL_STATUS, { isOpened: boolean }>;

const reducer = (state = initialState, action: CollaboratorsAction) => {
  switch (action.type) {
    case types.RECEIVE_COLLABORATORS:
      return {
        ...state,
        list: action.payload,
      };
    case types.SET_MODAL_STATUS:
      return dot.merge(state, 'modalStatus', action.payload);
    default:
      return state;
  }
};

export default reducer;
